export default __webpack_public_path__ + "aee9a359185bb059e39c34a987b42d3b.png";